import React, { useEffect, useState } from 'react';
import {v4 as  uuidV4} from 'uuid';
import DatabaseDocument from '../../helpers/CreateSheet';
import Axios from 'axios';
import Logout from '../../helpers/Logout';
import { useNavigate } from 'react-router-dom';

export default function SheetMenus(props) {

    const {docx} = props;
    const date = new Date();
    //const [docxCopy, setDocxCopy] = useState();
    const navigate = useNavigate();

    async function CreateDocxCopy()
    {
        let details = await getDetails(docx.urlkey);
        const id = uuidV4();
        let data = {
            urlkey: id,
            name: `Copy of ${details.name}`,
            // owner: ,
            contents: details.contents,
            viewers: [],
            editors: [],
            dateCreated: `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`,
            lastEdited: `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`
        }
        //console.log(data);
        DatabaseDocument(data);
        window.open(`${window.location.origin}/document/${id}`)
    }

    //! Repeated this to get the Exact Same Detail's back from DB
    async function getDetails(documentId)
    {
        const url = `https://docsserver.onrender.com/sheets/sheetDetails/${documentId}`;

        try
        {
            let res = await Axios.get(url);
            if(res.data)
            {
                return(res.data[0]);
            }
            else
            {
                //!Must be Handled 🔻
            }
        }
        catch(err)
        {
            //console.log(err);
        }

    }

    async function DeleteDocx()
    {
        if(window.confirm('⚠️ Are you Sure, Do you want to Delete ?') == true)
        {

            const url = `https://docsserver.onrender.com/deleteDoc/del/${docx.urlkey}`;

            let result = await Axios.delete(url);

            if(result.data == 'deleted')
            {
                navigate(`/`)
            }
            else
            {
                //! Error
            }
        }
    }

    

    return (
        <div className='ml-5 group'>
            <button><svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h7" />
            </svg></button>
            <div className='absolute hidden bg-white group-hover:block shadow-lg'>
                <p onClick={() => CreateDocxCopy()} className='py-2 pl-3 pr-10 hover:bg-slate-200 cursor-pointer transition-all duration-200'>Make a Copy</p>
                <p onClick={() => DeleteDocx()} className='px-3 py-2 hover:bg-red-600 hover:text-white cursor-pointer flex justify-start align-middle items-center'>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>Delete</p>
                <p onClick={() => Logout()} className='flex py-2 pl-3 pr-10 hover:bg-slate-200 cursor-pointer transition-all duration-200'><svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>Logout</p>
            </div>
        </div>
    )
}
